import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Check Outline".
 *
 * @property {string} [tooltip] - The tooltip to display on hover.
 */
@Component({
    selector: 'app-icon-check-outline',
    templateUrl: './icon-check-outline.component.html',
    styleUrls: ['./icon-check-outline.component.scss'],
    standalone: false
})
export class IconCheckOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
